import { ref, onMounted, onUnmounted } from 'vue'

const useInfiniteScroll = ({ observeRef, onIntersecting }) => {
  const observer = ref(null)

  const createObserver = () => {
    observer.value = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onIntersecting()
        }
      })
    })
  }

  const observeElement = () => {
    if (observer.value && observeRef.value) {
      observer.value.observe(observeRef.value)
    }
  }

  const unobserveElement = () => {
    if (observer.value && observeRef.value) {
      observer.value.unobserve(observeRef.value)
    }
  }

  onMounted(() => {
    createObserver()
    observeElement()
  })

  onUnmounted(() => {
    unobserveElement()
  })

  return {
    observer,
    observeElement,
    unobserveElement,
  }
}

export default useInfiniteScroll
